import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_WORK_ORDER_TEMPLATES = `${TASK_SERVICE}/work-order-templates`;

export const workOrderTemplates = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_WORK_ORDER_TEMPLATES,
      method: "get",
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id } = {}) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: API_WORK_ORDER_TEMPLATES,
      method: "post",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES}/${id}`,
      method: "patch",
      data,
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
  getHomeTemplates: async ({
    id,
    filters,
    sort,
    params,
    signal,
    top,
    skip,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES}/homes/${id}`,
      method: "get",
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  updateConfigById: async ({
    id,
    data,
    modifiedOn,
    toastMessageConfig,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES}/${id}`,
      method: "patch",
      data,
      modifiedOn,
    });
    return apiRequest(options, toastMessageConfig);
  },
  updateAutoAssignmentWindows: async ({
    id,
    data,
    toastMessageConfig = {},
  }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES}/${id}/time-windows`,
      method: "put",
      data,
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
